import { przezmorzeBatchApi } from "../../../api/api";

export async function getCustomersCsv(abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeBatchApi.get<Blob>(`/customer-export/csv`, {
    signal: abortSignal,
    headers: { Accept: "application/csv" },
    responseType: "blob",
  });
  return response.data;
}

export async function getCustomerContactPersonCsv(abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeBatchApi.get<Blob>(`/customer-export/contact-person-csv`, {
    signal: abortSignal,
    headers: { Accept: "application/csv" },
    responseType: "blob",
  });
  return response.data;
}

export async function getCustomerNotesCsv(abortSignal?: AbortSignal): Promise<Blob> {
  const response = await przezmorzeBatchApi.get<Blob>(`/customer-export/notes-csv`, {
    signal: abortSignal,
    headers: { Accept: "application/csv" },
    responseType: "blob",
  });
  return response.data;
}
